import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const collectorsColumns: ColumnFormatted[] = [
  { type: "string", key: "collectionneursDescriptionType", visible: true },
  { type: "string", key: "collectionneursDescriptionCivilite", visible: true },
  { type: "string", key: "collectionneursDescriptionPrenom", visible: true },
  { type: "string", key: "collectionneursDescriptionNom", visible: true },
  { type: "string", key: "collectionneursDescriptionNomTri" },
  { type: "string", key: "collectionneursDescriptionNomPublic" },
  { type: "string", key: "collectionneursDescriptionVille", visible: true },
  { type: "string", key: "collectionneursDescriptionLieu", visible: true },
  { type: "string", key: "collectionneursDescriptionRue", visible: true },
  {
    type: "string",
    key: "collectionneursDescriptionCodePostal",
    visible: true,
  },
  { type: "string", key: "collectionneursDescriptionPays", visible: true },
  { type: "boolean", key: "collectionneursDescriptionCollectionPublique" },
  { type: "string", key: "collectionneursDescriptionNomContact" },
  { type: "string", key: "collectionneursDescriptionTelephoneMobile" },
  { type: "string", key: "collectionneursDescriptionTelephone" },
  { type: "string", key: "collectionneursDescriptionAdresseMail" },
  { type: "string", key: "collectionneursDescriptionSiteWeb" },
  { type: "richtext", key: "collectionneursDescriptionNotes" },
  { type: "richtext", key: "sources" },
];

export const collectorsColumnsVisibility = collectorsColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible ?? true,
  }),
  {} as Record<string, boolean>,
);

export const collectorsAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "collectorsDescription",
    fields: [
      { type: "string", key: "collectionneursDescriptionType" },
      { type: "string", key: "collectionneursDescriptionCivilite" },
      { type: "string", key: "collectionneursDescriptionPrenom" },
      { type: "string", key: "collectionneursDescriptionNom" },
      { type: "string", key: "collectionneursDescriptionNomTri" },
      { type: "string", key: "collectionneursDescriptionNomPublic" },
      { type: "string", key: "collectionneursDescriptionLieu" },
      { type: "string", key: "collectionneursDescriptionRue" },
      { type: "string", key: "collectionneursDescriptionCodePostal" },
      { type: "string", key: "collectionneursDescriptionVille" },
      { type: "string", key: "collectionneursDescriptionPays" },
      { type: "boolean", key: "collectionneursDescriptionCollectionPublique" },
      { type: "string", key: "collectionneursDescriptionNomContact" },
      { type: "string", key: "collectionneursDescriptionTelephoneMobile" },
      { type: "string", key: "collectionneursDescriptionTelephone" },
      { type: "string", key: "collectionneursDescriptionAdresseMail" },
      { type: "string", key: "collectionneursDescriptionSiteWeb" },
      { type: "string", key: "collectionneursDescriptionNotes" },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
